import * as React from "react";
import Box from "@mui/material/Box";
import {
  FormControl,
  Grid,
  TextField,
  Tooltip,
  IconButton,
  MenuItem,
  Button,
  Drawer,
} from "@mui/material";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { get, postJsonData } from "../network/ApiController";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useState } from "react";
import { useEffect } from "react";
import { whiteColor } from "../theme/setThemeColor";


let defaultOperator = "operator";
const ClaimCollections = ({ refresh,row }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);

  const [operator, setOperator] = useState("");
  const [operatorVal, setOperatorVal] = useState([]);
  

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    bgcolor: "background.paper",
    boxShadow: 24,
    fontFamily: "Poppins",
    p: 2,
    height: "max-content",
    overflowY: "scroll",
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = {
       id:row.id,
      remark: form.remark.value,
    };
    setRequest(true);
    postJsonData(
      ApiEndpoints.CLAIM,
      data,
      setRequest,
      (res) => {
        okSuccessToast(res.data.message||"success");
        handleClose();
        if (refresh) refresh();
      },
      (error) => {
        if (refresh) refresh();
        apiErrorToast(error);
      }
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
      }}
    >
<Tooltip title="Claim">
<Button
  variant="outlined"
  className="refresh-icon-risk"
  disabled={row.status === "Claimed"}
  onClick={handleOpen}
  sx={{
    py: 0.3,
    color: row.status === "Claimed" ? '#f28b82' : 'primary.main',           
    borderColor: row.status === "Claimed" ? '#f28b82' : 'primary.main',    
    backgroundColor: row.status === "Claimed" ? '#fdecea' : 'transparent',  
    '&.Mui-disabled': {
      color: '#f28b82',          
      borderColor: '#f28b82',      
      backgroundColor: '#fdecea',   
    },
    '&:hover': {
      borderColor: row.status === "Claimed" ? '#f28b82' : 'primary.dark', 
      backgroundColor: row.status === "Claimed" ? '#fdecea' : 'primary.lighter',  
    },
  }}
>
{row.status === "Claimed" ? "Already Claimed" : "Claim"}

</Button>

</Tooltip>




      <Drawer
        open={open}
        anchor="right"
        onClose={handleClose}
    
      >
        <Box sx={{width:400}} className="sm_modal">
          <ModalHeader title="Claim Collections" handleClose={handleClose}subtitle="Simplify Your Workflow: Add New version" />
          <Box
            component="form"
            id="addversion"
            validate="true"
            autoComplete="off"
            onSubmit={handleSubmit}
            sx={{
              "& .MuiTextField-root": { m: 1 },
            }}
          >
            <Grid container sx={{ pt: 1 }}>
          
    
              <Grid item md={12} xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField autoComplete="off"
                    label="Remark"
                    id="remark"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{mr:"10px"}}>
          <ModalFooter form="addversion" request={request} />
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};
export default ClaimCollections;
